import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-unknown",
  "use": "icon-unknown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unknown\">\r\n    <path d=\"M145.6 0C100.8 0 64 36.8 64 81.6v860.8C64 987.2 100.8 1024 145.6 1024h732.8c44.8 0 81.6-36.8 81.6-81.6V324.8L657.6 0h-512z\" fill=\"#8199AF\" p-id=\"1712\" />\r\n    <path d=\"M960 326.4v16H755.2s-100.8-20.8-99.2-108.8c0 0 4.8 92.8 97.6 92.8H960z\" fill=\"#617F9B\" p-id=\"1713\" />\r\n    <path d=\"M657.6 0v233.6c0 25.6 17.6 92.8 97.6 92.8H960L657.6 0z\" fill=\"#FFFFFF\" p-id=\"1714\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/unknown.svg
// module id = wOos
// module chunks = 15 16